import { Http } from './request.util.js'

var site = window.g.site

var Index = {
	getWxJsSdkInfo(data){
		return Http.request({
			url: site + '/index/index/getWxJsSdkInfo',
			data: data,
			showLoading: false
		})
	}
}
var Auth = {
	getWxAuthUrl(data){
		return Http.request({
			url: site + '/index/Auth/getWxAuthUrl',
			data: data
		})
	},
	getWxAuthInfo(data){
		return Http.request({
			url: site + '/index/Auth/getWxAuthInfo',
			data: data
		})
	}
}

var Account = {
	getQrCode(){
		return Http.request({
			url: site + '/index/Account/getQrCode',
			showLoading: false
		})
	},
	loginStatus(){
		return Http.request({
			url: site + '/index/Account/loginStatus',
			showLoading: false
		})
	},
	twiceLogin(){
		return Http.request({
			url: site + '/index/Account/twiceLogin'
		})
	},
	offLogin(){
		return Http.request({
			url: site + '/index/Account/offLogin'
		})
	},
	passwordLogin(data){
		return Http.request({
			url: site + '/index/Account/passwordLogin',
			data: data
		})
	}
}

var Member = {
	getInfo(){
		return Http.request({
			url: site + '/index/Member/index',
			showLoading: false
		})
	}
}

var Group = {
	get(){
		return Http.request({
			url: site + '/index/Group/get'
		})
	},
	refresh(){
		return Http.request({
			url: site + '/index/Group/refresh'
		})
	},
	selectGroup(data){
		return Http.request({
			url: site + '/index/Group/selectGroup',
			data: data
		})
	},
	getUnusedList(){
		return Http.request({
			url: site + '/index/Group/getUnusedList'
		})
	}
	
	
}

var GroupCenter = {
	get(data){
		return Http.request({
			url: site + '/index/Group_Center/get',
			data: data,
			showLoading: false
		})
	}
}

var GroupCenterSrc = {
	saveFile(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/saveFile',
			data: data,
			showLoading: false
		})
	},
	get(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/get',
			data: data,
			showLoading: false
		})
	},
	post(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/post',
			data: data,
			showLoading: false
		})
	},
	del(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/del',
			data: data,
			showLoading: false
		})
	},
	find(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/find',
			data: data,
			showLoading: false
		})
	},
	users(data){
		return Http.request({
			url: site + '/index/Group_Center_Src/users',
			data: data,
			showLoading: false
		})
	}
}

var Buy = {
	
	getProduct(){
		return Http.request({
			url: site + '/index/Buy/getProduct',
			showLoading: false
		})
	}
	
}

var Order = {
	createOrder(data){
		return Http.request({
			url: site + '/index/Order/createOrder',
			data: data
		})
	},
	checkOrder(data){
		return Http.request({
			url: site + '/index/Order/checkOrder',
			data: data,
			showLoading: false
		})
	}
}
var Login = {
	getCode(data){
		return Http.request({
			url: site + '/index/Login/getCode',
			data: data
		})
	},
	index(data){
		return Http.request({
			url: site + '/index/Login/index',
			data: data
		})
	}
}

var Feedbook = {
	post(data){
		return Http.request({
			url: site + '/index/Feedbook/post',
			data: data
		})
	}
}
var Codes = {
	post(data){
		return Http.request({
			url: site + '/index/Codes/post',
			data: data
		})
	}
}

var Setting = {
	index(){
		return Http.request({
			url: site + '/index/Setting/index'
		})
	}
}

var Help = {
	index(){
		return Http.request({
			url: site + '/index/Help/index',
			showLoading: false
		})
	}
}

var Agent = {
	index(){
		return Http.request({
			url: site + '/index/Agent/index'
		})
	},
	post(){
		return Http.request({
			url: site + '/index/Agent/post'
		})
	}
}

export default {
	Agent,
	Help,
	Setting,
	Feedbook,
	Codes,
	Index,
	Auth,
	Account,
	Member,
	Group,
	Buy,
	GroupCenter,
	GroupCenterSrc,
	Order,
	Login
}